import { TrendMetric } from './trend-metric/trend-metric';
export type MetricSelectionType = 'HISTORY' | 'FOREIGN_CCY_BREAKDOWN' | 'THROUGHPUT' | 'SUSPENSE_BALANCE';
export class MetricSelection {
    constructor(
        public selectionType: MetricSelectionType,
        public currency: string,
        public metricType: string,
        public metricDescription,
        public metric?: TrendMetric) {
    }
}
